export const firebaseConfig = {
  apiKey: "AIzaSyCYWbJ-WMenEB49Vq44S3gUCtKtWZ1i4J4",
  authDomain: "moi-operator.firebaseapp.com",
  projectId: "moi-operator",
  storageBucket: "moi-operator.firebasestorage.app",
  messagingSenderId: "274484938608",
  appId: "1:274484938608:web:e1b6cc2bdab5e1e01371b5",
  measurementId: "G-W10XL4K6Z3",
};

export const firebaseVapidKey =
  "BMwNeXyZVGhv1RS4hZn80Au-Geig87LoyOTArowd4jYyHHBFF-5dNq--NoDq5JqHrfrWEmxUyxJUVtHKqcMOwSs";
